/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect, useLayoutEffect } from 'react';
import canUseDom from '../canUseDom/canUseDom.js';

var themeSetEventName = 'header-theme-set';
var key = 'ibmcloud:theme-switcher';

// useIsomorphicLayoutEffect will check that window is defined and
// switch to the appropriate hook since useLayoutEffect does not
// work with server-side rendering.
var useIsomorphicLayoutEffect = canUseDom ? useLayoutEffect : useEffect;
var themes = {
  light: 'themeLight',
  dark: 'themeDark'
};
function getOSThemePreference() {
  var _window;
  if ((_window = window) !== null && _window !== void 0 && (_window = _window.matchMedia('(prefers-color-scheme: dark)')) !== null && _window !== void 0 && _window.matches) {
    return themes.dark;
  }
  return themes.light;
}
function getThemePreference(savedPreference, getOSTheme) {
  if (savedPreference === 'themeDefault') {
    return getOSThemePreference();
  }
  if (!savedPreference && getOSTheme === true) {
    return getOSThemePreference();
  }
  if (savedPreference) {
    return savedPreference;
  }
  return themes.light;
}
function useThemePreference() {
  var getOSTheme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var _useState = useState(themes.light),
    _useState2 = _slicedToArray(_useState, 2),
    theme = _useState2[0],
    setTheme = _useState2[1];
  useIsomorphicLayoutEffect(function () {
    var savedPreference = localStorage.getItem(key);
    setTheme(getThemePreference(savedPreference, getOSTheme));
  }, []);
  useEffect(function () {
    var updateTheme = function updateTheme(_ref) {
      var detail = _ref.detail;
      setTheme(detail.theme);
    };
    window.addEventListener(themeSetEventName, updateTheme);
    return function () {
      return window.removeEventListener(themeSetEventName, updateTheme);
    };
  }, []);
  return theme;
}

export { useThemePreference as default, themes };
